import Main from './Main'

export default [
  { path: '/relatorios', component: Main, name: 'relatorios.main' }
]



// WEBPACK FOOTER //
// ./src/app/relatorios/routes.js